<emma-modal (close)="onClose()" size="lg" [noFooter]="false">
    <ng-container class="emma-modal-title">
        <i class="la la-spell-check" aria-hidden="true"></i>
        <span>{{ headTitle }}</span>
    </ng-container>
    <ng-container class="emma-modal-body">
        <span class="row">
            <div *ngIf="type === EMMA_TEXT_CHECK_MODAL_TYPE.AUDIENCE_TAGS" class="col-md-12">
                <div *ngIf="itemsToCheck.length">
                    <p>{{ bodyMessage }}</p>
                    <ul>
                        <ng-container *ngFor="let item of itemsToCheck">
                            <li class="m--margin-bottom-10">
                                {{ item.label }}
                                ({{ item.audiences.length }}
                                <span *ngIf="item.audiences.length === 1" i18n>audiencia)</span>
                                <span *ngIf="item.audiences.length > 1" i18n>audiencias)</span>
                                <div>
                                    <span>{{ item.audiences | join: 'name' }}</span>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div *ngIf="!itemsToCheck.length">
                    {{ emptyCheckMessage }}
                </div>
            </div>
        </span>
    </ng-container>
    <ng-container class="emma-modal-footer">
        <button emmaButton [color]="confirmColor" [isWide]="true" (click)="onClose()">
            {{ confirmText }}
        </button>
    </ng-container>
</emma-modal>
